<div class="subnav__wrapper border-r border-gray-300">
  @if (header()) {
    <div class="flex justify-between items-center mb-8">
      <h3 class="flex-1">{{ header() | transloco }}</h3>

      @if (settingsLink()) {
        <ui-icon class="cursor-pointer flex-shrink-0" icon="griddy-settings" [routerLink]="[settingsLink]"></ui-icon>
      }
    </div>
  }

  <ng-content></ng-content>
</div>
